import { render, staticRenderFns } from "./averages.vue?vue&type=template&id=000413f9&scoped=true"
import script from "./averages.vue?vue&type=script&lang=js"
export * from "./averages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000413f9",
  null
  
)

export default component.exports